import { memo } from "react";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import ListableTaskCardWrapper from "@coworker/apprestructured/src/task-management/components/TaskCard/wrappers/NormalTaskWrapper/ListableTaskCardWrapper";
import LoadingTaskCard from "@coworker/apprestructured/src/task-management/components/TaskCard/components/LoadingTaskCard/LoadingTaskCard";

function LoadingTaskCardDemo() {
  return (
    <Demo>
      <Name>LoadingTaskCard (listable)</Name>
      <Highlight>
        <ListableTaskCardWrapper>
          <LoadingTaskCard />
        </ListableTaskCardWrapper>
      </Highlight>
    </Demo>
  );
}

export default memo(LoadingTaskCardDemo);
